export const getClipperState = (state) => state.getIn(['app', 'clipper']);
